"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateAnswersMatchScore = aggregateAnswersMatchScore;
const process_single_answer_1 = require("./process-single-answer");
function aggregateAnswersMatchScore(userAnswers, candidateAnswers) {
    const initialScore = { score: 0, weight: 0 };
    return userAnswers.reduce((totalScore, userAnswer) => {
        const matchingAnswers = candidateAnswers.filter((candidateAnswer) => candidateAnswer.questionId === userAnswer.questionId);
        return matchingAnswers.reduce((currentTotal, singleMatch) => {
            const resultStep = (0, process_single_answer_1.processSingleAnswer)(userAnswer, singleMatch);
            return {
                score: currentTotal.score + resultStep.score,
                weight: currentTotal.weight + resultStep.weight,
            };
        }, totalScore);
    }, initialScore);
}
